export class ICDCode {
    public id = '';
    public name = '';
    public category = '';
    public description = '';
    public billRate: number;
}
